import { m } from 'framer-motion';
// @mui
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
// components
import { MotionViewport, varFade } from 'src/components/animate';

// ----------------------------------------------------------------------

const CARDS = [
  {
    icon: ' /assets/icons/home/ic_make_brand.svg',
    title: 'Branding',
    description: "Branding services can be just as important to your business success as branding a product. Your brand tells customers that you're a pit-bull lawyer, a compassionate hospital, or an experienced, savvy business guru.",
  },
  {
    icon: ' /assets/icons/home/ic_design.svg',
    title: 'UI & UX Design',
    description:
      'We offer compelling UI UX design services for immersive web experiences. Let us help you build interactive, compelling and intuitive websites.',
  },
  {
    icon: ' /assets/icons/home/ic_development.svg',
    title: 'Web Development Services',
    description: 'We provide customized and modernized website solutions that are tailored and designed for your services and products, to suit your needs.',
  },
  {
    icon: ' /assets/icons/home/ic_development.svg',
    title: 'Mobile App Development',
    description: 'Mobile apps enable digital convergence and it has become more important than ever for businesses to deliver personalized experiences. We develop native, cross-platform, and hybrid mobile applications for a wide range of industries and businesses.',
  },
  {
    icon: ' /assets/icons/home/ic_make_brand1.svg',
    title: 'Software Testing Services',
    description: 'SPEC INDIA’s QA experts are experienced and use a multitude of software testing methodologies and technologies to ensure well-functioning software.',
  },
  {
    icon: ' /assets/icons/home/ic_design1.svg',
    title: 'Technology Training',
    description: 'Since technology and software can change often, helping your team learn how to operate updated devices and software can help them use those tools efficiently with minimal questions. ',
  },
];

// ----------------------------------------------------------------------

export default function HomeMinimal() {

  return (
    <Container
      component={MotionViewport}
      sx={{
        py: { xs: 10, md: 15 },
      }}
    >
      <Stack
        spacing={3}
        sx={{
          textAlign: 'center',
          mb: { xs: 5, md: 10 },
        }}
      >
        <m.div variants={varFade().inDown}>
          <Typography variant="h2">
            Services Include
          </Typography>
        </m.div>
        <m.div variants={varFade().inUp}>
          <Typography component="div" variant="overline" sx={{ color: 'text.disabled' }}>
            The slide showcases range of information technology services offered by company for customers.
          </Typography>
        </m.div>
      </Stack>

      <Box
        gap={{ xs: 3, lg: 10 }}
        display="grid"
        alignItems="center"
        gridTemplateColumns={{
          xs: 'repeat(1, 1fr)',
          md: 'repeat(3, 1fr)',
        }}
      >
        {CARDS.map((card, index) => (
          <m.div variants={varFade().inUp} key={card.title}>
            <Card
              sx={{
                textAlign: 'center',
                boxShadow: { md: 'none' },
                bgcolor: 'background.default',
                p: (theme) => theme.spacing(10, 5),
                ...((index === 0 || index === 2 || index === 4 || index === 6) && {
                  boxShadow: (theme) => ({
                    md: `-40px 40px 80px ${theme.palette.mode === 'light'
                      ? alpha(theme.palette.grey[500], 0.16)
                      : alpha(theme.palette.common.black, 0.4)
                      }`,
                  }),
                }),
              }}
            >
              <Box
                component="img"
                src={card.icon}
                alt={card.title}
                sx={{ mx: 'auto', width: 48, height: 48 }}
              />

              <Typography variant="h5" sx={{ mt: 8, mb: 2 }}>
                {card.title}
              </Typography>

              <Typography sx={{ color: 'text.secondary' }}>{card.description}</Typography>
            </Card>
          </m.div>
        ))}
      </Box>
    </Container>
  );
}
